<div style="background-color: white; width: 100%; max-width: 538px; height: auto; display: flex; flex-direction: column; align-items: center; padding: 12px 16px 32px 16px;">
    <div style="width: 100%; display: flex; justify-content: flex-end;">
       <img (click)="closeDialog()" onKeyDown="" src="../../../assets/icons/gray_close.svg" alt="" style="width: 16px; height: 16px; cursor: pointer;"> 
    </div>
    <span class="fs-16px mt-2"><b>Cambio de estatus para proveedor - {{proveedor.proveedor.nombreProveedor}}</b></span>
    <form class="w-100" [formGroup]="estatusForm">
        
        <div class="d-flex flex-column w-100">
            <span class="w-100 fs-14px font-weight-bold">Estatus</span>
            <select class="w-100form-select form-select-lg" formControlName="estatus">
                <option value="">Selecciona una Opción</option>
                <option *ngFor="let item of estatus" [value]="item.estatusProveedorId">{{item.descripcion}}</option>
            </select>
            <span class="w-100 mt-2" *ngIf="estatusForm.value.estatus === '3' || estatusForm.value.estatus === '4'">Observaciones</span>
            <!-- <input *ngIf="estatusForm.value.estatus === '3'|| estatusForm.value.estatus === '4'" formControlName="observacion" class="form-control w-100" type="text" placeholder="Ingresa las observaciones del registro">  -->
            <textarea *ngIf="estatusForm.value.estatus === '3' || estatusForm.value.estatus === '4'" formControlName="observacion" class="form-control w-100" placeholder="Ingresa las observaciones del registro" rows="3"> </textarea>
        </div>   
    </form>

    <button class="btn btn-primary mt-4" (click)="guardarCambios()">Guardar cambios</button>
</div>